var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap-table" },
    [
      _c("SearchUsers", { attrs: { group: _vm.group } }),
      _c(
        "table",
        { staticClass: "table-users stripe" },
        [
          _c("th", [_vm._v("Nombre")]),
          _c("th", [_vm._v("Admin")]),
          _c("th", [_vm._v("Lider")]),
          _c("th", { staticClass: "text-center" }, [_vm._v("...")]),
          _vm._l(_vm.users, function(user, indextr) {
            return _c("tr", { key: indextr, attrs: { "data-cy": "user" } }, [
              _c("td", [
                _c("span", { staticClass: "d-flex" }, [
                  user.avatar
                    ? _c("img", {
                        key: "onlineImg",
                        staticClass: "rounded-full shadow-md cursor-pointer",
                        attrs: {
                          src: user.avatar,
                          alt: "user-img",
                          width: "40",
                          height: "40"
                        }
                      })
                    : _vm._e(),
                  !user.avatar
                    ? _c("img", {
                        key: "onlineImg",
                        staticClass: "rounded-full shadow-md cursor-pointer",
                        attrs: {
                          src: _vm.noAvatar,
                          alt: "user-img",
                          width: "40",
                          height: "40"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "ml-3",
                      staticStyle: { "line-height": "40px" }
                    },
                    [_vm._v(" " + _vm._s(user.nombre) + " ")]
                  )
                ])
              ]),
              _c(
                "td",
                [
                  user.esAdministradorEmpresa === "Y"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Administrador",
                              expression: "'Administrador'"
                            }
                          ],
                          attrs: { color: "warning" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "verified_user" } }),
                          _vm._v(" admin ")
                        ],
                        1
                      )
                    : _vm._e(),
                  user.esAdministradorEmpresa !== "Y"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "No admin",
                              expression: "'No admin'"
                            }
                          ]
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "verified_user" } }),
                          _vm._v(" no ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "td",
                [
                  user.esLider === "Y"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Lider",
                              expression: "'Lider'"
                            }
                          ],
                          attrs: { color: "success", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "flag" } }),
                          _vm._v(" lider ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "wrap-actions" },
                  [
                    _c(
                      "CheckPermission",
                      { attrs: { permission: "ED074" } },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Editar usuario",
                                expression: "'Editar usuario'"
                              }
                            ],
                            staticClass: "btn-icon rounded-circle",
                            attrs: { variant: "flat-primary" },
                            on: {
                              click: function($event) {
                                return _vm.editUser(user)
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "align-middle text-body p-0",
                              attrs: { size: "14", icon: "EditIcon" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.group.nombre && _vm.group.tieneLider === "N"
                      ? _c(
                          "CheckPermission",
                          { attrs: { permission: "ED073" } },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Lider",
                                    expression: "'Lider'"
                                  }
                                ],
                                staticClass: "btn-icon rounded-circle",
                                attrs: { variant: "flat-primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.markLeader(user)
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "align-middle text-body p-0",
                                  attrs: { size: "12", icon: "FlagIcon" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-dropdown",
                      {
                        attrs: { variant: "link", "no-caret": "", right: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function() {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "align-middle text-body",
                                    attrs: {
                                      size: "14",
                                      icon: "MoreVerticalIcon",
                                      "data-cy": "options"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "*",
                                expression: "'*'"
                              }
                            ],
                            attrs: { "data-cy": "user-detail" },
                            on: {
                              click: function($event) {
                                return _vm.detailUser(user)
                              }
                            }
                          },
                          [_vm._v(" Ver Detalle ")]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED097",
                                expression: "'ED097'"
                              }
                            ],
                            attrs: { "data-cy": "binnacle" },
                            on: {
                              click: function($event) {
                                return _vm.userBinnacle(user)
                              }
                            }
                          },
                          [_vm._v(" Bitácora ")]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED219",
                                expression: "'ED219'"
                              }
                            ],
                            attrs: { "data-cy": "groups-user" },
                            on: {
                              click: function($event) {
                                return _vm.groupsUser(user)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.titleActionUserGroups) + " "
                            )
                          ]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "in-environment",
                                rawName: "v-in-environment",
                                value: "desarrollo",
                                expression: "'desarrollo'"
                              },
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED086",
                                expression: "'ED086'"
                              }
                            ],
                            attrs: { "data-cy": "assign-roles" },
                            on: {
                              click: function($event) {
                                return _vm.assignRoles(user)
                              }
                            }
                          },
                          [_vm._v(" Asignar Roles ")]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "in-environment",
                                rawName: "v-in-environment",
                                value: "desarrollo",
                                expression: "'desarrollo'"
                              },
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED086",
                                expression: "'ED086'"
                              }
                            ],
                            attrs: { "data-cy": "copy-roles" },
                            on: {
                              click: function($event) {
                                return _vm.copyRoles(user)
                              }
                            }
                          },
                          [_vm._v(" Copiar Roles ")]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED152",
                                expression: "'ED152'"
                              }
                            ],
                            attrs: { "data-cy": "assign-profiles" },
                            on: {
                              click: function($event) {
                                return _vm.assignProfiles(user)
                              }
                            }
                          },
                          [_vm._v(" Asignar Perfiles ")]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED086",
                                expression: "'ED086'"
                              }
                            ],
                            attrs: { "data-cy": "copy-profiles" },
                            on: {
                              click: function($event) {
                                return _vm.copyProfiles(user)
                              }
                            }
                          },
                          [_vm._v(" Copiar Perfiles ")]
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED071",
                                expression: "'ED071'"
                              }
                            ],
                            attrs: { "data-cy": "substitute" },
                            on: {
                              click: function($event) {
                                return _vm.substituteUser(user)
                              }
                            }
                          },
                          [_vm._v(" Suplentes ")]
                        ),
                        _vm.company.firmaSimple
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: { "data-cy": "simple-signer" },
                                on: {
                                  click: function($event) {
                                    return _vm.simpleSigner(user)
                                  }
                                }
                              },
                              [_c("span", [_vm._v(" Firma Simple ")])]
                            )
                          : _vm._e(),
                        _vm.company.firmaAvanzada
                          ? _c(
                              "b-dropdown-item",
                              {
                                attrs: { "data-cy": "advanced-signer" },
                                on: {
                                  click: function($event) {
                                    return _vm.advancedSigner(user)
                                  }
                                }
                              },
                              [_c("span", [_vm._v(" Firma Avanzada ")])]
                            )
                          : _vm._e(),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: { "data-cy": "worker-data" },
                            on: {
                              click: function($event) {
                                return _vm.workerData(user)
                              }
                            }
                          },
                          [_c("span", [_vm._v(" Información laboral ")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          })
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "userGroups",
          attrs: { "hide-footer": "", title: _vm.titleModalUserGroups }
        },
        [
          _vm._l(_vm.userGroups, function(group) {
            return _c("div", { key: group.id, staticClass: "group-element" }, [
              _c("strong", [_vm._v("- ")]),
              _c("span", [_vm._v(_vm._s(group.nombre))])
            ])
          }),
          !_vm.userGroups.length
            ? _c("div", [_c("h4", [_vm._v("No se encontraron registros")])])
            : _vm._e()
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "user",
          attrs: {
            size: "lg",
            "hide-footer": "",
            title: "Datos del usuario",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("manage-user", {
            attrs: { action: _vm.actionUser, user: _vm.user },
            on: { "close-manage-user": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "binnacle",
          attrs: {
            size: "lg",
            "hide-footer": "",
            title: "Bitácora del usuario " + _vm.user.nombre
          }
        },
        [
          _c("binnacle-user", {
            attrs: { user: _vm.user, "binnacle-user": _vm.binnacleUser },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "substitute",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Suplencia para el usuario " + _vm.user.nombre
          }
        },
        [
          _c("substitute-user", {
            attrs: { user: _vm.user },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "simplesign",
          attrs: {
            centered: "",
            id: "simple-signature-modal",
            "modal-class": "modal-primary",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Firma Simple"
          }
        },
        [
          _c("FormConfigureSign", {
            attrs: { user: _vm.user, type: "simple", ambit: "unidad" }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "advancedSign",
          attrs: {
            centered: "",
            id: "advances-signature-modal",
            "modal-class": "modal-primary",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            "title-class": "w-100"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("div", [
                      _vm._v(_vm._s("Firma Avanzada - " + _vm.getSignName()))
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.user.nombre))])
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("FormConfigureSign", {
            attrs: { user: _vm.user, type: "avanzada", ambit: "unidad" },
            on: { cancel: _vm.cancelAdvancesSing }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "assignRolesModal",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Asignar Roles a " + _vm.user.nombre
          }
        },
        [
          _c("assign-roles-form", {
            attrs: { user: _vm.user },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "assignProfilesModal",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Asignar Perfiles a " + _vm.user.nombre
          }
        },
        [
          _c("assign-profiles-form", {
            attrs: { user: _vm.user },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "copyRolesModal",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Copiar Roles desde " + _vm.user.nombre
          }
        },
        [
          _c("copy-roles-users", {
            attrs: { user: _vm.user, "users-general": _vm.usersGeneral },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "copyProfilesModal",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Copiar Perfiles desde " + _vm.user.nombre
          }
        },
        [
          _c("copy-profiles-users", {
            attrs: { user: _vm.user, "users-general": _vm.usersGeneral },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "workerInformationModal",
          attrs: {
            centered: "",
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Información laboral de " + _vm.user.nombre
          }
        },
        [
          _c("WorkerInformation", {
            attrs: { user: _vm.user },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }